<app-waiting-loader *ngIf="!isLoading"></app-waiting-loader>
<router-outlet *ngIf="!isLoading"></router-outlet>


<!-- <div class="wrapper" *ngIf="!login">
    <app-sidebar class="aside-container"></app-sidebar>
    <app-offsidebar class="offsidebar"></app-offsidebar>
    <section class="section-container"> 
        <div class="content-wrapper">
            <router-outlet></router-outlet>
        </div>
    </section>
    <footer class="footer-container" app-footer></footer>
</div>

<div *ngIf="login">
    <app-waiting-loader *ngIf="!isLoading"></app-waiting-loader>
    <router-outlet *ngIf="!isLoading"></router-outlet>
</div> -->